import { POSTHOG_UTM_CONTEXT_FIELDS, sanitizePostHogEventContext } from "./posthog-event-context";

type FirstTouchClient = {
	has_opted_out_capturing(): boolean;
	get_property(name: string): unknown;
	register_once(properties: Record<string, string>): void;
};

/** Freeze missing fields too, so a later campaign cannot become the first touch. */
export function registerPostHogFirstTouch(client: FirstTouchClient, href: string): void {
	try {
		if (client.has_opted_out_capturing()) return;
		const url = new URL(href);
		const campaigns: Record<string, unknown> = {};
		for (const [field, property] of Object.entries(POSTHOG_UTM_CONTEXT_FIELDS)) {
			campaigns[field] = client.get_property(`$initial_${property}`) ?? url.searchParams.get(property);
		}
		const context = sanitizePostHogEventContext(campaigns);
		client.register_once(
			Object.fromEntries(
				Object.entries(POSTHOG_UTM_CONTEXT_FIELDS).map(([field, property]) => [
					`first_touch_${property}`,
					context[field as keyof typeof POSTHOG_UTM_CONTEXT_FIELDS] ?? "",
				]),
			),
		);
	} catch {
		// A missing SDK or malformed location must not interrupt initialization.
	}
}
